export enum ScheduleDialogMessagesEnum {
  ApplyScheduleTitle = 'Applying Schedule',
  ApplyScheduleSuccess = 'New settings applied successfully',

  UpdateScheduleTitle = 'Schedule updating',
  UpdateScheduleSuccess = 'Schedule successfully updated',

  DeleteScheduleTitle = 'Schedule deleting',
  DeleteScheduleSuccess = 'Schedule successfully deleted',
  DeleteScheduleError = 'Please select the schedule to remove',

  TurnOnScheduleTitle = 'Schedule turning on',
  TurnOnScheduleSuccess = 'Schedule successfully turned on',

  TurnOffScheduleTitle = 'Schedule turning off',
  TurnOffScheduleSuccess = 'Schedule successfully turned off',
  TurnOffScheduleError = 'Please select the schedule to disable',
}
